<template>
  <div>
    <el-badge is-dot :hidden="filtersEmpty()">
      <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="openDialog()"
      >
        Filters
      </el-button>
    </el-badge>
    <el-dialog :visible.sync="dialog" width="500px" top="13vh" :modal="false">
      <p>Video Title</p>
      <el-input
        type="text"
        v-model="title"
        clearable
        placeholder="Video Title"
      />
      <div slot="footer">
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import isNull from 'lodash/isNull'

export default {
  data() {
    return {
      dialog: false,
      title: '',
      email: '',
      date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ]
    }
  },

  computed: {
    ...mapState('labelVideos', ['loading'])
  },

  methods: {
    ...mapActions('labelVideos', ['readMyVideos']),
    ...mapMutations('labelVideos', ['setPage', 'setPageSize']),

    filter() {
      this.setPage(1)
      let filter_data = {
        title: this.title
      }
      localStorage.setItem('video_report_filter', JSON.stringify(filter_data))
      this.readMyVideos(filter_data)
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('video_report_filter'))
      if (ls) {
        const { ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    },

    openDialog() {
      this.dialog = true

      let ls = localStorage.getItem('video_report_filter')
      let f = JSON.parse(ls)

      if (!isNull(f)) {
        this.title = f.title
        this.email = f.email
      }
    }
  },

  created() {
    this.filtersEmpty()
  }
}
</script>
